import React from 'react';

import { CustomMarkdown } from '@nw/shared/ui';

import { ClientBasedDescriptionSectionContainer } from './styledComponents';

interface ClientBasedDescriptionSectionProps {
  content: string;
}
const ClientBasedDescriptionSection: React.FC<
  ClientBasedDescriptionSectionProps
> = ({ content }) => {
  return (
    <ClientBasedDescriptionSectionContainer className="client-based-description-section">
      <CustomMarkdown content={content} />
    </ClientBasedDescriptionSectionContainer>
  );
};

export { ClientBasedDescriptionSection };
